export * as errors              from './errors';
export * as function            from './function';
export * as string              from './string';
export * as object              from './object/index';
export * as DateWrapper         from './DateWrapper';
export * as translationsManager from './translationsManager';
export * as languageProcessing  from './languageProcessing/index';
export * as colors              from './colors';
export * as math                from './math';
export * as events              from './events';
export * as DOM                 from './DOM/index';
export * as misc                from './misc';
export * as net                 from './net';
export const sessionId = _STD.string.random(5);
import * as _STD                from './';

declare global {
	interface Window {
		STD : typeof _STD;
		MPASTD : typeof _STD;
	}
}
;
(<Record<string, unknown>> globalThis).STD = _STD;
(<Record<string, unknown>> globalThis).MPASTD = _STD;
